import * as styles from "@/styles/modules/DiagonalFrosting.module.scss"

const DiagonalFrosting = ({ className, color }) => {
  return (
    <svg
      className={className ? `${styles.shape} ${className}` : styles.shape}
      viewBox="0 0 427 774"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{ fill: color }}
        d="M427 0c-32 28-36 75-40 121-4 38-8 76-27 102-23 32-54 46-84 60-35 16-69 31-87 76-17 42-9 80-2 118 8 37 15 73 0 111-18 45-52 60-93 79l-13 6c-46 21-65 48-80 101H0V0h427z"
        fill="#1A1418"
      />
    </svg>
  )
}

export default DiagonalFrosting
